module.exports = __webpack_public_path__ + "ed2c4435ccb7efc44377f8a12bd6788f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2065_teaser_image.jpg
// module id = 584
// module chunks = 0